<template>
  <div
    v-if="definitions"
    class="btn-action-price">
    <wptv-button
      v-for="(definition, key) in definitions"
      :key="key"
      :data-wptv="'banniere-' + (definition.usage === 'RENT' ? 'louer' : 'acheter')"
      :aria-label="createAriaLabel(item, definition)"
      type="full"
      background="black"
      @click.native="$emit('select', definition)">
      <span v-if="definition.discountPrice !== null">
        <span class="promo">
          <span v-if="definition.discountPrice > 0">
            {{ usage(definition) }} {{ definition.discountPrice| formatPrice }} €
          </span>
          <span v-else>
            {{ definition.usage === 'RENT' ? $t('fip.buttons.rentFree') : $t('fip.buttons.buyFree') }}
          </span>
        </span>
        <span class="barred">{{ definition.price| formatPrice }} €</span>
      </span>
      <span v-else>
        <span v-if="definition.price > 0 ">
          {{ usage(definition) }} {{ definition.price | formatPrice }} €
        </span>
        <span v-else>
          {{ $t('fip.offert') }}
        </span>
      </span>
    </wptv-button>
  </div>
</template>

<script>
import { WptvButton } from '@wptv/components/ui/button'

export default {
  name: 'BtnActionPrice',
  components: { WptvButton },
  props: {
    definitions: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    /**
     *
     * @param item
     * @param definition
     * @returns {string}
     */
    createAriaLabel (item, definition) {
      const rentOrBuy = definition.usage === 'RENT' ? 'rent' : 'buy'
      const price = definition.discountId ? definition.discountPrice ?? 0 : definition.price ?? 0

      return price !== 0
        ? this.$t(`fip.accessibility.${rentOrBuy}`, { title: this.item.title, price: price.toString().replace('.', ',') })
        : this.$t('fip.accessibility.free', { title: this.item.title })
    },

    usage (definition) {
      return definition.usage === 'RENT' ? this.$t('fip.buttons.rentLabel') : this.$t('fip.buttons.buyLabel')
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-action-price {
    z-index: 2;
    display: flex;
    @include mediaQueries('flex-direction', (xsmall: column, medium: row));
    @include mediaQueries('margin', (xsmall: 0, medium: 20px 0 20px 0));

    button {
      max-width: unset;
      &:not(:only-child) {
      @include mediaQueries('margin-right', (xsmall: 0, medium: 30px));
      }
      &:first-child {
        @include mediaQueries('margin-bottom', (xsmall: 15px, medium: 0));
      }

      .barred {
        text-decoration: line-through;
      }

      .promo {
        margin-right: 8px;
        margin-left: 4px;
      }
    }
  }
</style>
